import React, { useState } from 'react';
import Cookies from 'js-cookie';

import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import StorefrontRoundedIcon from '@material-ui/icons/StorefrontRounded';

import SellerDialog from '@common_sellerdialog';
import Button from '@common_button';
import { useTranslation } from '@i18n';

import Modal from '@sellermodules/saleschannel/pages/add/components/Modal';
import useStyles from '@modules/theme/layout/components/seller/StoreReauthorizationModal/style';

const StoreReauthorizationModal = (props) => {
    const {
        handleReconnect, open, setOpen, storeNotAuthorized, loading,
    } = props;
    const classes = useStyles();

    const { t } = useTranslation('common');

    const [checked, setChecked] = useState(false);

    return (
        <>
            <Modal isReconnect {...props} t={t} callbackClose={() => setOpen(true)} />
            <SellerDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    Cookies.set('store_integration', checked ? 'skip' : 'close');
                }}
                showLeftButton={false}
                showRightButton={false}
                title={(
                    <div className={classes.titleWrapper}>
                        <StorefrontRoundedIcon classes={{ root: classes.titleIcon }} />
                        <div className={classes.titleText}>
                            <div className="primary">{t('common:Reconnect_Store')}</div>
                            <div className="secondary">
                                {/* eslint-disable-next-line max-len */}
                                {t('common:To_ensure_accurate_stock_and_order_synchronization_please_reconnect_your_store_across_all_sales_channels_as_soon_as_possible')}
                            </div>
                        </div>
                    </div>
                )}
                maxWidth="sm"
                action={(loading ? null
                    : (
                        <FormControlLabel
                            classes={{ root: classes.controlLabelRoot, label: classes.controlLabel }}
                            control={(
                                <Checkbox
                                    color="primary"
                                    checked={checked}
                                    onChange={(e) => setChecked(e.target.checked)}
                                    classes={{ root: classes.checkboxRoot, label: classes.checkboxLabel }}
                                    icon={<div className={classes.checkboxIcon} />}
                                    checkedIcon={<img src="/assets/img/checkbox-checked.svg" alt="checked" />}
                                />
                            )}
                            label={t("common:Don't_show_this_again")}
                        />
                    )
                )}
                enableClickOutside={false}
            >
                {loading
                    ? <div className={classes.loadingWrapper}><CircularProgress /></div>
                    : (
                        <div className={classes.cardsContainer}>
                            {storeNotAuthorized?.map((store) => (
                                <div className={classes.card}>
                                    <div className={classes.cardLabel}>
                                        <div
                                            className={classes.channelLogo}
                                            style={{ backgroundImage: `url(${store?.channel?.channel_logo || '/assets/img/placeholder_image.jpg'})` }}
                                        />
                                        {store?.store_name}
                                    </div>
                                    <Button
                                        className={classes.btn}
                                        onClick={() => handleReconnect(store)}
                                        user="seller"
                                    >
                                        {t('common:Connect')}
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}
            </SellerDialog>
        </>
    );
};

export default StoreReauthorizationModal;
